module.exports = __webpack_public_path__ + "img/stock.fb9594f2.svg";